export default __webpack_public_path__ + "static/media/B52_4.90561908.webp";